import React from 'react';

import { Button } from 'components/Misc/Form';
import Container from 'components/Misc/Container';

const Update = () => {
	// Handle click on update button
	const onReload = () => {
		window.location.reload(true);
	};

	return (
		<Container className="mb-4 mx-auto max-w-[1240px] w-full py-3 pl-4 pr-3 flex items-center">
			<div className="flex-1 font-bold text-neutral-800 dark:text-white transition-colors">
				Mācību videi ir pieejams atjauninājums!
			</div>
							
			<Button
				icon="autorenew"
				theme="success"
				value="Iegūt"
				onClick={onReload}
			/>
		</Container>
	);
};

export default Update;